export const CRYPTO_REWARDS_BUY_MODE_STEP_INVESTMENTS_AMOUNT = 'CRYPTO_REWARDS_BUY_MODE_STEP_INVESTMENTS_AMOUNT' as const

export const CRYPTO_REWARDS_BUY_MODE_STEP_CURRENCY_LIST = 'CRYPTO_REWARDS_BUY_MODE_STEP_CURRENCY_LIST' as const

export const CRYPTO_REWARDS_BUY_MODE_STEP_SEND_ORDER = 'CRYPTO_REWARDS_BUY_MODE_STEP_SEND_ORDER' as const

export const CRYPTO_REWARDS_BUY_MODE_STEP_SUCCESS = 'CRYPTO_REWARDS_BUY_MODE_STEP_SUCCESS' as const

export const CRYPTO_REWARDS_SELL_MODE_STEP_LOADING = 'CRYPTO_REWARDS_SELL_MODE_STEP_LOADING' as const

export const CRYPTO_REWARDS_SELL_MODE_STEP_CRYPTO_WALLET = 'CRYPTO_REWARDS_SELL_MODE_STEP_CRYPTO_WALLET' as const

export const CRYPTO_REWARDS_SELL_MODE_STEP_SELL_AMOUNT = 'CRYPTO_REWARDS_SELL_MODE_STEP_SELL_AMOUNT' as const

export const CRYPTO_REWARDS_SELL_MODE_STEP_PREVIEW_ORDER = 'CRYPTO_REWARDS_SELL_MODE_STEP_PREVIEW_ORDER' as const

export const CRYPTO_REWARDS_SELL_MODE_STEP_PENDING = 'CRYPTO_REWARDS_SELL_MODE_STEP_PENDING' as const

export const CRYPTO_REWARDS_SELL_MODE_STEP_SUCCESS = 'CRYPTO_REWARDS_SELL_MODE_STEP_SUCCESS' as const

export const CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_ENABLE = 'CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_ENABLE' as const

export const CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_CHOOSE_CURRENCY = 'CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_CHOOSE_CURRENCY' as const

export const CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_SENDING_REQUEST = 'CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_SENDING_REQUEST' as const

export const CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_SUCCESS = 'CRYPTO_REWARDS_AUTO_INVESTMENTS_MODE_STEP_SUCCESS' as const
